var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.0001C14.4183 18.0001 18 14.4184 18 10.0001C18 5.85522 14.8478 2.44657 10.8099 2.0406V11.6886L12.9257 9.75656C13.2381 9.46993 13.733 9.4848 14.0267 9.78972C14.1695 9.93761 14.2442 10.1308 14.2381 10.334C14.232 10.5375 14.1444 10.7262 13.992 10.8657L10.5474 14.0114C10.408 14.1387 10.224 14.2107 10.029 14.2145L10.0015 14.216L9.97867 14.2149C9.77638 14.2107 9.59238 14.1387 9.45333 14.0114L6.00876 10.8657C5.856 10.7262 5.76876 10.5375 5.76229 10.334C5.75657 10.1308 5.83124 9.93761 5.9741 9.78972C6.26781 9.4848 6.76229 9.47031 7.07467 9.75656L9.19086 11.6886V2.04053C5.15258 2.44614 2 5.85496 2 10.0001C2 14.4184 5.58172 18.0001 10 18.0001Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.7f0a1005.svg";
export { ForwardRef as ReactComponent };